import { render, staticRenderFns } from "./confirmationLearnMore.vue?vue&type=template&id=64a14d72"
import script from "./confirmationLearnMore.vue?vue&type=script&lang=js"
export * from "./confirmationLearnMore.vue?vue&type=script&lang=js"
import style0 from "./confirmationLearnMore.vue?vue&type=style&index=0&id=64a14d72&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a14d72')) {
      api.createRecord('64a14d72', component.options)
    } else {
      api.reload('64a14d72', component.options)
    }
    module.hot.accept("./confirmationLearnMore.vue?vue&type=template&id=64a14d72", function () {
      api.rerender('64a14d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/confirmationLearnMore.vue"
export default component.exports